/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////
export { DEFAULT_PROPS } from './default-props';

/////////////////////////////////////////////
// COLOR CONFIGURATION
/////////////////////////////////////////////
export const BG_COLOR = {
  primary: 'rgba(240,237,230,1)',
  secondary: '#aba77f',
  tertiary: '#a78e55',
  alternative: '#F4F4F4',
};

export const TEXT_COLOR = {
  primary: '#8a805f',
  secondary: '#8a805f',
  tertiary: '#a78e55',
  alternative: '#000',
};

export const ASSET_PATTERN_COLOR = '#aba77f';

export const NAVIGATION_COLOR = {
  base: BG_COLOR.secondary,
  icon: TEXT_COLOR.alternative,
};

export const INPUT_COLOR = {
  background: '#ADABAC',
  color: TEXT_COLOR.tertiary,
};

export const DIVIDER_PATTERN_PROPS = {
  position: 'absolute',
  className: 'divider-pattern_cover',
  width: '100%',
  height: '110px',
  left: '0',
  overflow: 'hidden',
  zIndex: 0,
  opacity: '0.15',
};
